<template>
  <div>
    <a-form ref="form" :rules="rules" :model="form" :label-col="{ span: 2 }" :wrapper-col="{ span: 17 }">
      <a-form-item label="关键词" prop="replaceValue">
        <a-input v-model="form.replaceValue" allowClear placeholder="请输入关键词" style="width: 40%" @change="changeReplaceValue"/>
      </a-form-item>
      <a-form-item label="选择模板" prop="template_id">
        <a-checkbox-group v-model="form.template_id" @change="onChange">
          <div style="display: inline-block; margin-right: 35px;" v-for="(item, i) in templateOptions" :key="item.id" >
            <a-checkbox :key="item.id" :value="item.id"> {{ item.template_name }} </a-checkbox>
            <a-icon style="font-size:12px;margin-left:3px;color:red;" type="form" @click="(e)=>editTemplate(e, item)"/>
            <a-icon style="font-size:12px;margin-left:3px;color:#1890ff;" type="delete" @click="(e)=>deleteTemplate(e, item, i)"/>
          </div>
          <a-button type="dashed" @click="addTemplate">添加模板</a-button>
        </a-checkbox-group>
      </a-form-item>

      <template v-if="tabOptions.length">
        <a-tabs style="padding-left: 60px;" v-model="activeTab" @change="changeTab">
          <a-tab-pane v-for="item in tabOptions" :key="item.id" :tab="item.template_name">
            <!-- <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 17 }"> -->
            <a-form-item label="文章标题">
              <a-input v-model="item.form.title" allowClear placeholder="请输入文章标题" style="width: 40%" />
            </a-form-item>
            <a-form-item label="小标题">
              <a-input v-model="item.form.title2" allowClear placeholder="请输入小标题" style="width: 40%" />
            </a-form-item>
            <a-form-item label="关键词">
              <a-input v-model="item.form.keywords" allowClear placeholder="请输入关键词" style="width: 40%" />
            </a-form-item>
            <a-form-item label="文章内容">
              <div class="article-content" v-html="item.form.content"></div>
            </a-form-item>
          <!-- </a-form> -->
          </a-tab-pane>
        </a-tabs>
      </template>
    </a-form>

    <a-divider/>

    <div style="padding-left: 60px;">
      <a-button type="primary" :loading="sbtLoading" @click="batchCreateArticle">生成文章</a-button>
      <a-button style="margin-left:20px;" @click="close">关闭</a-button>
    </div>

  </div>
</template>

<script>
import api from '@/api/'
import { forEach, reject } from 'lodash'

export default {
  data() {
    return {
      form: {
        replaceValue: '',
        keywords: '',
        title: '',
        title2: '',
        template_id: [],
        content: ''
      },
      rules: {
        replaceValue: [{ required: true, message: '请输入', trigger: 'blur' }],
        template_id: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      templateOptions: [],
      activeTab: '1',
      tabOptions: [],
      sbtLoading: false
    }
  },

  mounted() {
    this.loadTemplate()
  },

  methods: {
    onChange(value) {
      this.tabOptions = []
      this.templateOptions.forEach(item => {
        if (value.includes(item.id)) {
          const replaceKey = `{{${item.replace_keyword}}}`
          const word = this.form.replaceValue
          item.form = {
            title: word ? item.title.replaceAll(replaceKey, word) : item.title,
            title2: word ? item.title2.replaceAll(replaceKey, word) : item.title2,
            content: word ? item.content.replaceAll(replaceKey, word) : item.content,
            keywords: word ? item.keywords.replaceAll(replaceKey, word) : item.keywords
          }
          this.tabOptions.push(item)
        }
      })
      if (this.tabOptions.length) { this.activeTab = this.tabOptions[0].id }
    },
    changeReplaceValue() {
      const word = this.form.replaceValue
      if (!word) return
      this.tabOptions.forEach(item => {
        const replaceKey = `{{${item.replace_keyword}}}`
        Object.keys(item.form).forEach(key => {
          item.form[key] = item[key].replaceAll(replaceKey, word)
        })
      })
    },
    changeTab() {},
    addTemplate() {
      this.$router.push('/article/edittemplate')
    },
    async loadTemplate() {
      const res = await api.articleTemplateItems()
      if (res.code === '000000') {
        this.templateOptions = (res.data && res.data.list) || []
      }
    },
    async batchCreateArticle() {
      if (!this.tabOptions.length) return this.$message.warning('请先选择模板')
      this.sbtLoading = true
      for (let i = 0; i < this.tabOptions.length; i++) {
        const form = {
          line_id: this.tabOptions[i].line_id, // 发布平台
          typeid: this.tabOptions[i].typeid, // 文章分类
          title: this.tabOptions[i].form.title, // 标题
          title2: this.tabOptions[i].form.title2, // 小标题
          is_rand: this.tabOptions[i].is_rand, // 是否随机阅读
          publisher_id: this.tabOptions[i].publisher_id, // 发布者id
          author: this.tabOptions[i].author, // 作者
          label_ids: this.tabOptions[i].label_ids, // 标签ID
          keywords: this.tabOptions[i].form.keywords, // 关键词
          content: this.tabOptions[i].form.content // 文章内容
        }
        await api.createArticle(form)
      }
      this.sbtLoading = false
      this.$message.success('已生成文章')
    },
    editTemplate(e, item) {
      this.$router.push({ path: '/article/edittemplate', query: { id: item.id } })
    },
    deleteTemplate(e, item, i) {
      const that = this
      this.$confirm({
        title: '删除模板',
        content: '你正在删除模板，请谨慎操作，删除后不可恢复，但已经生成的文章不受影响。',
        okText: '删除',
        cancelText: '取消',
         onOk() {
          return new Promise(async (resolve, reject) => {
          const res = await api.articleTemplateDelete({ id: item.id })
            if (res.code === '000000') {
              that.$message.success('已删除')
              that.templateOptions.splice(i, 1)
            }
            resolve()
        })
        },
      })
    },
    close() {
      this.$router.go(-1)
    },
  },
}
</script>
